import { Component, Input } from '@angular/core';
import { OfferService } from '../../_services/offer/offer.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '../../_services/shared.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ShoppingCartService } from '../../_services/shopping-cart.service';
import { catchError, ignoreElements, map, of, shareReplay } from 'rxjs';
import { Offer } from '../../model/offer';
import { CommonModule } from '@angular/common';
// import { OfferPhotoTermsComponent } from '../offer-photo-terms/offer-photo-terms.component';
import { ThemeService } from '../../_services/theme.service';
import { LxResponsiveClassDirective } from '../../directives/lx-responsive-class.directive';

@Component({
    selector: 'app-shopping-cart-list-modal',
    standalone: true,
    imports: [CommonModule, LxResponsiveClassDirective],
    templateUrl: './shopping-cart-list-modal.component.html',
    styleUrl: './shopping-cart-list-modal.component.scss'
})
export class ShoppingCartListModalComponent {


  @Input()
  propertyId: string = '';
  @Input()
  offerAliasId: string = '';
  @Input()
  selectedOffers: { offerSetId: string; offerId: string; offer: Offer; }[] | undefined = [];

  offerPhotoTermsReference: any;
  acknowledgment: boolean = false;

  constructor(private offerService: OfferService,
              private router: Router,
              private route: ActivatedRoute,
              public sharedService: SharedService,
              public shoppingCartService: ShoppingCartService,
              public modalRef: BsModalRef,
              private modalService: BsModalService,
              public themeService: ThemeService
              ){
  }

  toggleAcknowledgment(){
    this.acknowledgment = !this.acknowledgment;
  }

  getLateCheckoutEarlyCheckinOffer(checkOutType: string) {
    this.offerService.createOfferFromAlias(this.offerAliasId, this.propertyId, true)
                            .pipe(shareReplay(1),
                                  map(offers => {
                                    this.sharedService.offers = offers;
                                    const offer = offers.find((ofr: Offer) => ofr.upsell_room_category_cd.substring(0, 3) === checkOutType.toUpperCase());
                                    if (offer) {
                                      this.sharedService.offer = offer;
                                      this.openModalTermsAndConditions(offer);
                                    }
                                  }
                                ),
                                ignoreElements(),
                                catchError((err) => {
                                    // this.router.navigate(['/offerNotAvailable']);
                                  return of(err)})
                              ).subscribe();

  }

  openModalTermsAndConditions(offer: Offer) {
    console.log('openModalTermsAndConditions', offer);
    // this.modalService.show(OfferPhotoTermsComponent, {
    //   ...this.sharedService.config,
    //   initialState: {
    //     offer: offer,
    //     propertyId: this.propertyId,
    //     offerAliasId: this.offerAliasId
    //   }
    // });
  }


  closeModal(){
    this.modalRef.hide();
    document.body.style.overflow = 'auto';
    document.documentElement.style.overflow = 'auto';
    document.documentElement.classList.remove("modal-open");
    document.body.classList.remove("modal-open");
  }


  public checkOut() {
    this.shoppingCartService.openCheckOutOfferTermsModal(this.offerAliasId, this.propertyId);
    this.closeModal()
  }



  navigateConfirmationValidation(){
    this.router.navigate(['/offerConfirmationValidation/' + this.offerAliasId + '/' + this.propertyId], { relativeTo: this.route })
  }

  navigateToOfferFormEmail(){
    this.router.navigate(['/offerGuestEmail/' + this.offerAliasId + '/' + this.propertyId], { relativeTo: this.route })
  }


  public totalSelectedOffers: number = 0;
  public totalQuantity: number = 0;
  public totalPrice: number = 0;

  public getTotalPrice(): number {

    let offerSets = this.shoppingCartService.getAllOffersForOfferAliasId(this.offerAliasId);
    if (!offerSets || offerSets.length === 0) {
      return 0;
    }

    let totalPrice = 0;

    offerSets.forEach(ofr => {
      if(ofr.offer.upsell_room_category_cd.startsWith('ECI') || ofr.offer.upsell_room_category_cd.startsWith('LCO'))
      {
        totalPrice += ofr.offer.ofr_price;
      } else {
        totalPrice += ofr.offer.ofr_price * ofr.offer.los;
      }

    });
    return totalPrice;
  }

  public getTotalQuantity(): number {

    let offerSets = this.shoppingCartService.getAllOffersForOfferAliasId(this.offerAliasId);
    if (!offerSets || offerSets.length === 0) {
      return 0;
    }

    let totalQuantity = 0;

    offerSets.forEach(ofr => {
      if(ofr.offer.upsell_room_category_cd.startsWith('ECI') || ofr.offer.upsell_room_category_cd.startsWith('LCO'))
      {
        totalQuantity += 1;
      } else {
        totalQuantity += ofr.offer.los;
      }

    });
    return totalQuantity;
  }


  public getItemQuantity(offer: Offer): number {
    if (!offer || !offer.los) {
      return 0;
    }
    if(offer.upsell_room_category_cd.startsWith('ECI') || offer.upsell_room_category_cd.startsWith('LCO')) {
      return 1;
    }
    return offer.los;
  }

  public getItemPrice(offer: Offer): number {
    if (!offer || !offer.los) {
      return 0;
    }
    if(offer.upsell_room_category_cd.startsWith('ECI') || offer.upsell_room_category_cd.startsWith('LCO')) {
      return offer.ofr_price;
    }
    return offer.ofr_price * offer.los;
  }


}
